import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environment/environment';

@Component({
  selector: 'app-maintenance-banner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="maintenance-banner" *ngIf="showBanner" role="status" aria-live="polite">
      <p class="maintenance-message">{{ message }}</p>
    </section>
  `,
  styles: [`
    .maintenance-banner {
      background: #fff4cc;
      border-bottom: 1px solid #e3cf87;
      color: #563f00;
      padding: 12px 16px;
    }

    .maintenance-message {
      margin: 0;
      font-size: 13px;
      line-height: 1.4;
      white-space: pre-line;
    }
  `],
})
export class MaintenanceBannerComponent implements OnInit {
  message: string = '';

  showBanner: boolean = false;

  ngOnInit(): void {
    const configuredMessage = environment.maintenance_banner_message || '';
    this.message = configuredMessage.trim();
    this.showBanner = this.message.length > 0;
  }
}
